/* eslint-disable */
import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);


const router = new Router({
    mode: "history",
    routes: [
        {
            path: "/",
            name: "intro",
            component: () =>
                import("@/views/pages/00/page-010")
        },
        {
            path: "/Module/Tokyo/",
            name: "intro",
            component: () =>
                import("@/views/pages/00/page-010")
        },
        {
            path: "/Module/Tokyo/pages/:kapitel/:pageid",
            name: "pages",
            linkActiveClass: "active",
            props: true,
            component: () =>
                import("@/views/pages/PageWrapper")
        },
    ]
})


router.beforeEach((to, from, next) => {
    // redirect to login page if not logged in and trying to access a restricted page
    /*const publicPages = ['/login', '/registerSuchend', '/registerVermieter', '/resetPassword', '/newPassword'];
    const authRequired = !publicPages.includes(to.path);
    const loggedIn = localStorage.getItem('user');

    if (authRequired && !loggedIn) {
        return next('/login');
    } */

    next();
})
router.beforeResolve((to, from, next) => {
    // If this isn't an initial page load.
    if (to.name) {

    }
    next()
})

router.afterEach((to, from) => {
    // Complete the animation of the route progress bar.

})

export default router